import { Button } from '@mui/material';

export default function ButtonCustom({
  icon,
  title,
  size = 'small',
  variant = 'outlined',
  color = 'primary',
  disabled,
  onClick,
  className,
  ...rest
}) {
  return (
    <Button
      size={size}
      color={color}
      variant={variant}
      startIcon={icon}
      onClick={onClick}
      disabled={disabled}
      {...rest}
      className={className}
    >
      {title}
    </Button>
  );
}
